import React from 'react';
import { FormattedMessage } from 'react-intl';
import { type MapStateToProps, connect } from 'react-redux';

import * as BackstageConstants from '../constants';
import * as D from '../deps';

import BackstageSocialLinkButtonRow from './BackstageSocialLinkButtonRow';

export interface IBackstageAboutStateProps {
  isMobileWeb: ReturnType<typeof D.isMobileWeb>;
  currentPathName: ReturnType<typeof D.getCurrentPathnameFromState>;
}

export interface IBackstageAboutOwnProps {
  pandoraId: string;
  bio: string;
  shareableUrlPath?: string;
  backgroundImgUrl: string;
  backgroundImgAlt?: string;
  shortTextWidthRatio?: number;
  socialLinks: {
    twitterUrl?: string;
    instagramUrl?: string;
    facebookUrl?: string;
    websiteUrl?: string;
  };
  isFirstSection?: boolean;
}

export type IBackstageAboutProps = IBackstageAboutStateProps & IBackstageAboutOwnProps;

const BackstageAbout: React.FC<IBackstageAboutProps> = props => {
  const {
    pandoraId,
    bio,
    socialLinks,
    backgroundImgUrl,
    isMobileWeb,
    shareableUrlPath,
    isFirstSection,
  } = props;
  const hasSocialLinks = Object.values(socialLinks).some(value => !!value);

  const linkUrl = shareableUrlPath && D.getBackstageFullBioPathForShareUrl(shareableUrlPath);

  const socialLinksContent = hasSocialLinks && (
    <BackstageSocialLinkButtonRow
      // @ts-expect-error TS(2322) Type '{ twitterUrl: string; instagramUrl: string; facebookUrl: string;...
      hasBackgroundImg={false}
      {...props.socialLinks}
    />
  );

  return (
    <React.Fragment>
      {(bio || (!isMobileWeb && socialLinksContent)) && (
        <D.ContentSection
          title={bio ? <FormattedMessage {...BackstageConstants.messages.about} /> : null}
          isAbout={true}
          moreText={isMobileWeb && <FormattedMessage {...BackstageConstants.messages.readMore} />}
          // @ts-expect-error TS(2322) Type 'string | false | undefined' is not assignable to type 'string
          moreUrl={isMobileWeb && linkUrl}
          isFirstSection={isFirstSection}
        >
          <D.DescriptionBackstageWithLogger
            // @ts-expect-error TS(2322) FIXME: Type '{ pandoraId: any; text: any; linkUrl: string... Remove this comment to see the full error message
            pandoraId={pandoraId}
            text={bio}
            linkUrl={linkUrl}
            linkText={BackstageConstants.messages.readMore}
            isExpanded={false}
            shortTextWidthRatio={2}
            hasBackgroundImg={!!backgroundImgUrl}
            shouldShowSeeMore={!isMobileWeb}
          />
          {!isMobileWeb && socialLinksContent}
        </D.ContentSection>
      )}
      {isMobileWeb && socialLinksContent && (
        <D.ContentSection title={<FormattedMessage {...BackstageConstants.messages.links} />}>
          {socialLinksContent}
        </D.ContentSection>
      )}
    </React.Fragment>
  );
};

export const mapStateToProps: MapStateToProps<
  IBackstageAboutStateProps,
  IBackstageAboutOwnProps,
  $TSFixMe
> = state => {
  return {
    isMobileWeb: D.isMobileWeb(state),
    currentPathName: D.getCurrentPathnameFromState(state),
  };
};

export default connect(mapStateToProps)(BackstageAbout);
